import { render, staticRenderFns } from "./OrderTheList.vue?vue&type=template&id=7f1958d8&scoped=true&"
import script from "./OrderTheList.vue?vue&type=script&lang=js&"
export * from "./OrderTheList.vue?vue&type=script&lang=js&"
import style0 from "./OrderTheList.vue?vue&type=style&index=0&id=7f1958d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1958d8",
  null
  
)

export default component.exports